import PropTypes from 'prop-types';

import color from 'core/libs/color';

import themePropTypes from 'core/utils/prop-types/theme';
import { isRamblerIdEnabled } from 'core/utils/rcm';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';
import ButtonWithIcon from 'core/components/ButtonWithIcon';

import SberIcon from './images/sber.svg';

import styles from './index.styl';

function LoginPopup(props, context) {
  const {
    theme,
    handleAuth,
  } = props;

  const {
    controls: {
      login: {
        popup: popupAtoms,
      },
    },
  } = theme;

  if (!isRamblerIdEnabled(context)) {
    return null;
  }

  const popupContentColor = popupAtoms.theme === 'dark'
    ? color(theme.colors.primary).alpha(0.4).string()
    : popupAtoms.content.color;

  return (
    <div className={styles.content}>
      <style jsx>{`
        .buttonText
          font ${popupAtoms.button.font}
          color ${popupAtoms.button.color}
          text-transform none
          letter-spacing normal

        .${styles.description}
          font ${popupAtoms.content.font}
          color ${popupContentColor}

        .link
          color ${popupContentColor}

          &:active,
          &:visited
            color ${popupContentColor}
      `}
      </style>
      <ButtonWithIcon
        className={styles.button}
        onClick={handleAuth}
        icon={SberIcon}
        minWidth={0}
        radius='8px'
        type='primary'
        size='medium'
        iconPosition='left'
      >
        <span className='buttonText'>Войти по Сбер ID</span>
      </ButtonWithIcon>
      <div className={styles.description}>
        Продолжая, Вы&nbsp;принимаете
        {' '}
        <a
          className='link'
          target='_blank'
          rel='noreferrer noopener'
          href='https://help.rambler.ru/legal/1430'
        >
          Условия
        </a>
        &nbsp;и&nbsp;
        <a
          className='link'
          target='_blank'
          rel='noreferrer noopener'
          href='https://help.rambler.ru/legal/1142'
        >
          Политику конфиденциальности
        </a>
        {' '}
        Rambler&Co&nbsp;ID
      </div>
    </div>
  );
}

LoginPopup.propTypes = {
  handleAuth: PropTypes.func,
  /** @ignore */
  theme: themePropTypes(`{
    controls: {
      login: {
        popup: {
          theme,
          button: { font, color },
          content: { font, color },
          background,
        },
      },
    },
  }`),
};

LoginPopup.contextTypes = {
  ramblerId: PropTypes.object,
};

const LoginPopupWithHOCs = withTheme(withBreakpoint(LoginPopup));
LoginPopupWithHOCs.displayName = 'LoginPopup';

export { LoginPopup as StorybookComponent };
export default LoginPopupWithHOCs;
